"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdownButtonNeoDark = exports.dropdownButtonNeoLight = exports.dropdownButtonNovoDark = exports.dropdownButtonNovo = exports.dropdownButton = void 0;
const polished_1 = require("polished");
const oxygen_theme_1 = __importDefault(require("@8x8/oxygen-theme"));
const color_const_1 = __importDefault(require("../choices/color.const"));
const spacing_const_1 = __importDefault(require("../choices/spacing.const"));
const size_const_1 = __importDefault(require("../choices/size.const"));
const zIndex_const_1 = __importDefault(require("../choices/zIndex.const"));
const button_const_1 = require("./button.const");
const { light, dark, neoLight, neoDark } = oxygen_theme_1.default;
const dropdownButton = {
    button: {
        ...button_const_1.button,
    },
    indicatorLeftMargin: size_const_1.default.default,
    indicatorScale: 1,
    indicatorColor: color_const_1.default.steel700,
    indicatorColorDisabled: color_const_1.default.cloudyBlue,
    dropdownOffset: '0',
    dropdownMaxHeight: '200px',
    dropdownMaxWidth: '200px',
    dropdownPadding: `${spacing_const_1.default.xxs} 0`,
    dropdownBackgroundColor: color_const_1.default.white,
    dropdownBorderColor: color_const_1.default.cloudyBlue300,
    dropdownShadowSize: size_const_1.default.shadowDefault,
    dropdownShadowColor: color_const_1.default.cloudyBlue300,
    dropdownZIndex: zIndex_const_1.default.z3000,
    dropdownBorderRadius: '0px',
    isClassic: true,
};
exports.dropdownButton = dropdownButton;
const dropdownButtonNovo = {
    isClassic: false,
    button: button_const_1.buttonNovo,
    indicatorLeftMargin: light.spacing03,
    indicatorScale: undefined,
    dropdownOffset: '0',
    dropdownMaxHeight: '192px',
    dropdownMaxWidth: '160px',
    dropdownPadding: `${light.spacing03} 0`,
    dropdownShadowSize: '0px 1px 2px',
    dropdownZIndex: 3000,
    dropdownBorderRadius: '6px',
    indicatorColor: light.icon05,
    indicatorColorDisabled: light.disabled04,
    dropdownBackgroundColor: light.ui06,
    dropdownBorderColor: light.ui01,
    dropdownShadowColor: (0, polished_1.rgba)(light.ui04, 0.25),
};
exports.dropdownButtonNovo = dropdownButtonNovo;
const dropdownButtonNovoDark = {
    ...dropdownButtonNovo,
    button: button_const_1.buttonNovoDark,
    indicatorColor: dark.icon05,
    indicatorColorDisabled: dark.disabled04,
    dropdownBackgroundColor: dark.ui06,
    dropdownBorderColor: dark.ui01,
    dropdownShadowColor: (0, polished_1.rgba)(dark.ui04, 0.25),
};
exports.dropdownButtonNovoDark = dropdownButtonNovoDark;
const dropdownButtonNeoLight = {
    ...dropdownButtonNovo,
    button: button_const_1.buttonNeoLight,
    indicatorColor: neoLight.icon05,
    indicatorColorDisabled: neoLight.disabled04,
    dropdownBackgroundColor: neoLight.ui06,
    dropdownBorderColor: neoLight.ui01,
    dropdownShadowColor: (0, polished_1.rgba)(neoLight.ui04, 0.25),
};
exports.dropdownButtonNeoLight = dropdownButtonNeoLight;
const dropdownButtonNeoDark = {
    ...dropdownButtonNovoDark,
    button: button_const_1.buttonNeoDark,
    indicatorColor: neoDark.icon05,
    indicatorColorDisabled: neoDark.disabled04,
    dropdownBackgroundColor: neoDark.ui06,
    dropdownBorderColor: neoDark.ui01,
    dropdownShadowColor: (0, polished_1.rgba)(neoDark.ui04, 0.25),
};
exports.dropdownButtonNeoDark = dropdownButtonNeoDark;
